.root {
    display: flex;
    gap: var(--spacer-32);
    margin: 0;
    padding: 0;

    li::marker {
        font-size: 0;
    }
}
